import { useEffect, useMemo } from 'react';
import { EmployeeStatusEnum } from '@electricjs/core_entity-client';

import { useEmployeesMap } from '@/hooks/useEmployeesMap';
import { useGetOrganizationId } from '@/hooks/useGetOrganizationId';
import { useLazyGetOrganizationEmployeesQuery } from '@/redux/slices/organizationApiSlice';
import { Employee } from '@/types/employees';

export const useOrganizationEmployees = (): Employee[] => {
  const currentOrganizationId = useGetOrganizationId();
  const employeesMap = useEmployeesMap();

  const [getOrganizationEmployees, { data: employees }] =
    useLazyGetOrganizationEmployeesQuery();

  useEffect(() => {
    if (currentOrganizationId && !employeesMap.isEnabled) {
      getOrganizationEmployees({ organizationId: currentOrganizationId }, true);
    }
  }, [currentOrganizationId, employeesMap.isEnabled, getOrganizationEmployees]);

  // The request below gets ACTIVE employees only (the backend default when no
  // status is sent), so the central list is narrowed the same way.
  const activeEmployees = useMemo(
    () =>
      employeesMap.employees.filter(
        employee => employee.status === EmployeeStatusEnum.Active
      ),
    [employeesMap.employees]
  );

  if (employeesMap.isEnabled) {
    return activeEmployees;
  }

  return employees ?? [];
};
